<template>
  <div class="categories-list w-100 d-flex align-items-center flex-row flex-wrap justify-content-between">
    <div
      :class="`col-6 col-md-3 ${index == $route.params.categoryId ? 'active' : ''}`"
      v-for="(cat, index) in $attrs.categorias"
      :key="index"
    >
      <router-link :to="`/category/${index}/`" class="section">
        <div class="section-image">
          <img :src="getImage(cat.image)" :alt="cat.title" />
        </div>
        <h5>{{cat.title}}</h5>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    getImage(image) {
      const icons = require.context(
        "../assets/",
        true,
        /\.(png|jpe?g|gif|svg)(\?.*)?$/
      );
      return image ? icons(`./${this.$parent.$parent.site}/${image}`) : "";
    }
  }
};
</script>
<style lang="scss">
.categories-list {
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  & .active {
    & .section {
      background-color: rgba(0, 0, 0, 1);
      text-decoration: none;
      color: #fff;
    }
    & .section-image {
      filter: brightness(0) invert(1);
    }
  }
  & .section {
    background-color: #ffffff;
    min-width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px auto;
    color: #000;
    cursor: pointer;
    padding: 0 0 10px 0;
    &.router-link-exact-active,
    &:hover {
      background-color: rgba(0, 0, 0, 1);
      text-decoration: none;
      color: #fff;
      & .section-image {
        filter: brightness(0) invert(1);
      }
    }
    & h5 {
      font-weight: 700;
      font-size: 9px;
      text-align: center;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }
    & .section-image {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      & img {
        object-fit: contain;
        height: 60px;
      }
    }
  }
}
</style>